module.exports = require('./helpers/bundle-url').getBundleURL('gjBjl') + "logo-dark.a922e36b.svg";